import * as React from 'react';
import Slider from 'react-slick';

import {reportGalleryItemClick} from '../../utils/bi';

import * as s from './Gallery.scss';

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    className: s.gallery,
    slidesToScroll: 3,
    slidesToShow: 2.3334,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToScroll: 1,
          dots: false,
          slidesToShow: 1.66,
        }
      }
    ]
  }
;

export type GalleryItem = {
  key: string,
  img: string,
  href?: string,
};

export interface GalleryConfig {
  staticsBaseUrl: string;
  galleryItems: Array<GalleryItem>;
  key: string;
}

interface GalleryProps extends GalleryConfig {}

const Gallery: React.SFC<GalleryProps> = ({galleryItems, staticsBaseUrl}) => {
  const wrapWithLink = (href, content) => (
    <a
      href={href}
      key={href}
      target="_blank"
      data-hook="gallery-link"
      onClick={reportGalleryItemClick}
    >
      {content}
    </a>);

  return (
    <div data-foldname="gallery">
      <Slider  {...settings}>
        {
          galleryItems.map(({img, key, href}) => {
            const image = <img alt={key} key={key} src={`${staticsBaseUrl}${img}`}/>;
            return href ? wrapWithLink(href, image) : image;
          })
        }
      </Slider>
    </div>
  );

};

export default Gallery;
